import {http, HttpResponse} from 'msw';
import {SetupServerApi} from 'msw/lib/node';

import {mergeDeepRight} from 'ramda';

import {GetArticleCategoryListResponse, GetArticleCategoryResponse} from '../types';

const getArticleCategoryListMock: GetArticleCategoryListResponse = {
  categories: [
    {
      name: 'Aftermarket parts',
      code: 'AFTERMARKET_PARTS',
      active: true,
      system: false,
      isDefault: false,
      id: '76c80420-d279-4dd5-bfcb-49a9b160ffb2',
    },
    {
      name: 'Original parts',
      code: 'ORIGINAL_PARTS',
      active: true,
      system: false,
      isDefault: false,
      id: 'fb23c245-e237-4319-b988-c7d04328609b',
    },
    {
      name: 'Mercedes',
      code: 'MERCEDES',
      active: true,
      system: false,
      isDefault: false,
      id: '3431d41b-75b3-4a17-838f-e95a152059b3',
    },
    {
      name: 'Ford ',
      code: '333444',
      active: true,
      system: false,
      isDefault: false,
      id: '2cbc0266-cf96-4934-80fc-fa2ab2ef00b8',
    },
    {
      name: 'Uncategorized',
      code: 'UNCATEGORIZED',
      active: true,
      system: false,
      isDefault: true,
      id: 'fbc98755-466a-40f9-83cc-989f0f4ab174',
    },
  ],
};

const getArticleCategoryResponseMock = (
  configuration: Partial<GetArticleCategoryResponse> = {}
): GetArticleCategoryResponse =>
  mergeDeepRight(
    {
      name: 'Aftermarket parts',
      code: 'AFTERMARKET_PARTS',
      active: true,
      system: false,
      isDefault: false,
    },
    configuration
  );

const getArticleCategoryListResponseInterceptor = (server: SetupServerApi) =>
  server.use(
    http.get('*/warehouse/v1/article-category-list', () =>
      HttpResponse.json(getArticleCategoryListMock)
    )
  );

const postArticleCategoryResponseInterceptor = (server: SetupServerApi) =>
  server.use(http.post('*/warehouse/v1/article-category', () => HttpResponse.json()));

const patchArticleCategoryResponseInterceptor = (server: SetupServerApi) =>
  server.use(http.patch('*/warehouse/v1/article-category/*', () => HttpResponse.json()));

export const metadaWarehouseArticleCategoryApiMock = {
  getArticleCategoryListMock,
  getArticleCategoryResponseMock,
  getArticleCategoryListResponseInterceptor,
  postArticleCategoryResponseInterceptor,
  patchArticleCategoryResponseInterceptor,
};
